import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {Layers, TheRaveLayers} from "../view/TheRaveLayers";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {TheRave} from "../TheRave";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Translation} from "../../core/utils/Translation";
import {TimelineLite, TweenLite} from "gsap";
import {BitmapCountUp} from "../coutup/BitmapCountUp";
import {FontStyleConfig} from "../config/FontConfig";
import {TheRaveEnhancerReelController} from "../reels/TheRaveEnhancerReelController";
import {TheRaveSound} from "../sound/TheRaveSound";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class WinCapScreen extends ContinueScreen {

    private readonly IDEL_ANIMATION_NAMES:string[] = ["maxwin_05","maxwin_06"];
    private readonly ANIMATION_NAMES:string[] = ["maxwin_01","maxwin_02","maxwin_03","maxwin_04","maxwin_05","maxwin_06"];
    private _levelDuration: number = 7.4;
    private _played: PIXI.Text;
    private _tl: TimelineLite | null;

    private _isPlaying: boolean;
    private text: PIXI.Sprite;
    private animations: PIXI.spine.Spine[] = [];
    private countUp: BitmapCountUp;

    constructor() {
        super(TheRaveLayers.getLayer(Layers.SCREENS)!);
    }

    public show(onContinueCallBack: () => void) {
        this.reset();
        if (!this.text) {
            const style = FontStyleConfig.COUNT_UP_MAX_CAP;
            this.countUp = new BitmapCountUp(style);
            this.countUp.visible = false;
            this.countUp.anchor = 0.5;
            this.countUp.position.set(360, 590);

            this._played = new PIXI.Text("", new PIXI.TextStyle({
                fill: 0xffffff,
                fontFamily: OpenSans.FAMILY,
                wordWrap: false,
                fontWeight: FontWeight.BOLD,
                fontSize: 30
            }));
            this._played.anchor.set(0.5, 0.5);
            this._played.position.set(360, 560);

            this.text = new PIXI.Sprite();
            this.text.anchor.set(0.5, 0.5);
            this.text.position.set(360, 150);
        }

        this.addSpines();
        this._container.addChild(this.text);
        this._container.addChild(this.countUp);

        const data = TheRave.model.parsedGameData,
            spinPlayed = TheRave.model.parsedGameData.numberOfFreespinsPlayed,
            tl = new TimelineLite(),
            fadeOutScreenDuration:number = 1.871;
        this._played.text = Translation.translate("Spins played: ${spinPlayed}").replace("${spinPlayed}", spinPlayed.toString());
        SlotGame.keypadPlugin.hide();
        tl.add([() => {
            this.visible = true;
            this._isPlaying = true;
            this.onOrientationChanged();
            TheRaveSound.capWinStart();
            if(data.totalWin.toString().length < 12) {
                this.countUp.y = 550;
                this.countUp.scale.set(0.8, 0.8);
            } else {
                this.countUp.y = 535;
                this.countUp.scale.set(0.725, 0.725);
            }
        }, TheRave.fullScreenDimLayer.start(fadeOutScreenDuration)], 0);

        tl.add([
            () => {
                TheRave.waysWon.remove();
                this.countUp.visible = true;
                this.animations.forEach((animation:PIXI.spine.Spine,index:number)=>{
                    if (TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS && index === 4) {
                        animation.state.setAnimation(0, "capWin_US_animation", false);
                    }else{
                        animation.state.setAnimation(0, "animation", false);
                    }
                    animation.visible = true;
                });
                this.text.visible = true;
            },
            this.getCountUpAnimation()
        ], fadeOutScreenDuration);

        tl.add(() => TheRaveSound.capWinLoop(), fadeOutScreenDuration+this._levelDuration);
        tl.add([
            () => {
                this._played.visible = data.mode !== GameMode.NORMAL;
                TheRave.background.updateEnvironment(TheRave.model.currentParsedData.nextMode);
                TheRave.enhancerReels.forEach((reel: TheRaveEnhancerReelController) => {
                    reel.reelView.isFreeSpin = false;
                    reel.reelView.hide();
                });
                super.show(onContinueCallBack);
            }]);
        tl.add(() => {
            if(TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS){
                this.animations[4].state.setAnimation(0,"loop_US_animation", true);
            }else{
                this.animations[4].state.setAnimation(0,"loop", true);
            }
            this.animations[5].state.setAnimation(0,"loop", true);
            }, 17);
        this._tl = tl;
    }

    private getCountUpAnimation(): TimelineLite {
        const tl = new TimelineLite(),
            data = TheRave.model.parsedGameData,
            bet = data.playedBetValue,
            levels: number[] = [0, bet * 2500, bet * 10000, data.totalWin];

        for (let i: number = 1; i < levels.length; i++) {
            tl.add([
                this.countUp.getCountUpAnimation(levels[i - 1], levels[i], {duration: this._levelDuration, withoutSound:true})
            ]);
        }
        return tl;
    }

    public onOrientationChanged(): void {
        if (!this._isPlaying) {
            return;
        }
        this.countUp.maxTextWidth = NolimitApplication.screenBounds.width;
        this.countUp.updateCountUpTextPivot();
        super.onOrientationChanged();
    }

    protected close(): TimelineLite {
        const tl = new TimelineLite();
        if(this._tl){
            if(this._tl.isActive()){
                this._tl.pause();
                this._tl.kill();
            }
        }
        this._tl = null;
        tl.add([
            TweenLite.to(this, {duration: 1, alpha: 0}),
            TheRave.fullScreenDimLayer.stop(),
            () => {
                this._isPlaying = false;
                TheRaveSound.capWinStop();
            }
        ]);
        if (TheRave.model.isFreespin) {
            tl.add(() => {
                    TheRave.stickySymbol.hideMultiplier();
                    TheRave.background.updateEnvironment(TheRave.model.parsedGameData.nextMode);
                    TheRave.enhancerReels.forEach((reel: TheRaveEnhancerReelController) => reel.reelView.isFreeSpin = false);
                }, 0.871);
            TheRaveLayers.getRePositionLayers().forEach((layer:StageLayer|undefined)=>tl.add(TweenLite.to(layer!.position, {
                duration: 0.5,
                y: 0,
                ease: `power3.out`
            }),0.871));
        }

        tl.add(() => {
            const data = TheRave.model.parsedGameData;
            SlotGame.keypadPlugin.setWin(data.totalWin, data.showTotalWin, TheRave.isWinBelowStake());
            SlotGame.keypadPlugin.show();
            this.visible = false;
            this.alpha = 1;
            this._continueButton.visible = false;
            this.countUp.y = 0;
            this.countUp.visible = false;
            this._played.visible = false;
        });

        return tl;
    }

    private createAnimationSpine(name:string):PIXI.spine.Spine{
        const effect: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(name));
        effect.name = name;
        effect.position.set(360, 360);
        effect.visible = false;
        effect.autoUpdate = true;
        this._container.addChild(effect);
        return effect;
    }
    private addSpines():void{
        this.ANIMATION_NAMES.forEach((name:string)=>this.animations.push(this.createAnimationSpine(name)));
    }

    private reset(): void {
        if (this.text) {
            this.countUp.visible = false;
            this._played.visible = false;
            while(this.animations.length>0){
                this._container.removeChild(this.animations[0]);
                this.animations.shift();
            }
            this.text.visible = false;
        }
    }
}